export const DEFAULT_EMPTY_MESSAGE_TEST_ID = 'empty-message'
